import { render } from "./video-conferencing.vue?vue&type=template&id=7939e4cc&lang=pug"
import script from "./video-conferencing.vue?vue&type=script&setup=true&lang=js"
export * from "./video-conferencing.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__